import {AppPath} from "../Router/AppRouter.jsx";
import Api from "../services/api/Api.js";
import PageCache from "../services/cache/PageCache.js";

const env = import.meta.env;
const Config = {
    env: env.MODE ?? 'production',
    version: env.VITE_REACT_APP_VERSION ?? null,
    host: `${window.location.protocol}//${window.location.host}`,
    apiBaseUrl: env.VITE_REACT_APP_API_BASE_URL
        ? `${env.VITE_REACT_APP_API_BASE_URL.replace(/\/+$/, '')}${AppPath.apiRoot}`
        : `${window.location.protocol}//${window.location.host}${AppPath.apiRoot}`,
    apiCacheDriver: env.VITE_REACT_APP_API_CACHE_DRIVER ?? Api.CACHE_DRIVER.AUTO,
    apiCacheVersion: env.VITE_REACT_APP_API_CACHE_VERSION ?? null,
    pageCacheDriver: env.VITE_REACT_APP_PAGE_CACHE_DRIVER ?? PageCache.CACHE_DRIVER.AUTO,
    pageCacheVersion: env.VITE_REACT_APP_PAGE_CACHE_VERSION ?? null,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timezoneOffset: (new Date()).getTimezoneOffset() / 60,
};

export default Config;